import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { useAuth } from '../lib/useAuth'
import AuthLayout, { Field, SubmitButton, GoogleButton, Divider, Notice, AltLine } from '../components/AuthLayout'
import AuthWorkspaceStep from '../components/AuthWorkspaceStep'

/** /signup — name + email + password, Continue with Google, sign-in link. */
export default function SignUp() {
  const auth = useAuth({ mode: 'signup' })
  const [name, setName] = useState('')
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')

  const nextQ = auth.next && auth.next !== '/' ? `?next=${encodeURIComponent(auth.next)}` : ''

  // A brand-new account with no tenant → name the workspace (same card + theme).
  if (auth.pending) {
    return (
      <AuthLayout gauge title="Name your workspace" subtitle={`Signed in as ${auth.pending.email}`}>
        <Notice notice={auth.notice} />
        <AuthWorkspaceStep auth={auth} />
      </AuthLayout>
    )
  }

  return (
    <AuthLayout
      gauge
      title="Create your account"
      subtitle="Free to start — you only pay when you activate a service."
    >
      <Notice notice={auth.notice} />
      <GoogleButton onClick={auth.signInGoogle} disabled={!auth.configured || auth.busy} />
      <Divider />
      <form onSubmit={(e) => { e.preventDefault(); auth.signUpEmail({ name, email, password }) }}>
        <Field
          label="Your name" name="name" value={name} onChange={setName}
          placeholder="Jane Doe" autoComplete="name" autoFocus disabled={!auth.configured}
        />
        <Field
          label="Email" name="email" type="email" value={email} onChange={setEmail}
          placeholder="you@company.com" autoComplete="email" required disabled={!auth.configured}
        />
        <Field
          label="Password" name="password" type="password" value={password} onChange={setPassword}
          placeholder="At least 8 characters" autoComplete="new-password" required minLength={8} disabled={!auth.configured}
        />
        <SubmitButton busy={auth.busy} disabled={!auth.configured} busyLabel="Creating…">Create account</SubmitButton>
      </form>

      {!auth.configured && (
        <p className="rrauth__notice rrauth__notice--info" style={{ marginTop: 16 }}>
          Sign-up isn’t configured in this build.
        </p>
      )}

      <AltLine>
        Already have an account?{' '}
        <Link className="rrauth__link rrauth__link--accent" to={`/signin${nextQ}`}>Sign in</Link>
      </AltLine>
    </AuthLayout>
  )
}
